export function formatCurrency(value: number | string): string {
  const num = typeof value === "string" ? parseFloat(value.replace(/\D/g, "")) / 100 : value
  if (isNaN(num)) return ""
  return num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

/**
 * Formata um valor decimal vindo da API (ex: "25000000.00") para exibição pt-BR (ex: "25.000.000,00").
 */
export function formatDecimalToBRL(value: string | null | undefined): string {
  if (!value) return ""
  const num = parseFloat(value)
  if (isNaN(num)) return ""
  return num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function parseCurrencyToNumber(value: string): number {
  if (!value) return 0
  const cleaned = value.replace(/\./g, "").replace(",", ".")
  return parseFloat(cleaned) || 0
}

export function handleCurrencyInput(rawValue: string): string {
  const digits = rawValue.replace(/\D/g, "")
  if (!digits) return ""
  const num = parseInt(digits, 10) / 100
  return num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function formatPercentage(value: number | string): string {
  const num = typeof value === "string" ? parseFloat(value.replace(/\D/g, "")) / 100 : value
  if (isNaN(num)) return ""
  return num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function handlePercentageInput(rawValue: string): string {
  const digits = rawValue.replace(/\D/g, "")
  if (!digits) return ""
  const num = parseInt(digits, 10) / 100
  return num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
